import React from "react";
import "./App.css";
import "monday-ui-react-core/dist/main.css";
import Redirect from "./components/RedirectRequest";

const App = () => {
  return (
    <div className="App">
      <Redirect/>
    </div>
  );
};

export default App;
